import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'
import Button from '../Button';
import SendSeriesDetailCard from './SendSeriesDetailCard';
import { fetchSeriesData } from '../../../../custom/Apis/apis';
import { servicesManager } from '../../../../app/src/App';
import { Loader, useTheme } from '@ohif/ui';

const SendFilesModal = ({
  closeButton = true,
  isOpen = false,
  title,
  onClose,
  shouldCloseOnOverlayClick = true,
  containerDimensions = '100vw, 100vh',
  studyInstanceUID
}) => {
  if (!isOpen) return null;

  const { uiNotificationService } = servicesManager.services
  const { isDarkMode } = useTheme();

  const [seriesData, setSeriesData] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleOverlayClick = (e) => {
    if (shouldCloseOnOverlayClick && e.target === e.currentTarget) {
      onClose();
    }
  };

  const [width, height] = containerDimensions.split(',');

  const handleSendClick = () => {

    if (selectedItems.length === 0) {
      return;
    }

    navigate('/sendtoMachine', {
      state: {
        selectedItems,
        seriesData,
        isSendingSeries: true,
      },
    });
  }

  const formatTime = (timeString) => {
    if (!timeString) return '';

    const hours = parseInt(timeString.substring(0, 2), 10);
    const minutes = timeString.substring(2, 4);
    const period = hours >= 12 ? 'PM' : 'AM';

    const formattedHours = hours % 12 || 12; // Convert to 12-hour format
    return `${formattedHours}:${minutes} ${period}`;
  };

  const getSeriesDetails = async () => {
    setIsLoading(true);

    const payload = {
      queryParams: {
        limit: '21',
        includefield: 'all',
        offset: '0',
        orderby: 'SeriesNumber',
      },
      studyInstanceUID
    }

    try {
      const response = await fetchSeriesData(payload);
      if (response?.ok) {
        const data = await response?.json();
        console.log('first', data);
        setSeriesData(data);
      }
      else {
        uiNotificationService.show({
          title: "Error",
          type: "error",
          message: "Error while fetching the series details.",
          position: "topRight"
        })
        console.error('Error:', response?.status, response?.statusText);
        onClose();
      }
    }
    catch (error) {
      uiNotificationService.show({
        title: "Error",
        type: "error",
        message: "Error while fetching the series details.",
        position: "topRight"
      })
      console.error('Error fetching patient count:', error);
      onClose();
    }
    finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getSeriesDetails();
  }, []);

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 overflow-scroll"
      onClick={handleOverlayClick}
    >
      <div
        className={`relative px-6 py-4 rounded-lg shadow-lg ${isDarkMode ? 'bg-secondary-dark' : 'bg-white-modal'}`}
        style={{ width: width.trim(), height: height.trim() }}
      >
        {closeButton && (
          <button
            className="absolute top-4 right-4 text-black text-3xl"
            onClick={onClose}
          >
            &times;
          </button>
        )}
        {title && <h2 className="text-xl font-bold mb-1">{title}</h2>}
        <hr />
        {
          isLoading ? <div className='h-20'>
            <Loader isLoaderOpen={isLoading} />
          </div>
            :
            <div className="modal-content mt-4 overflow-y-auto h-96 min-h-[27rem]">
              <div className='flex flex-wrap gap-4'>
                {
                  seriesData?.map((item, idx) => {

                    const getValueSafely = (tag) => {
                      try {
                        const value = item?.[tag]?.Value?.[0];
                        if (tag === '00080020' && value) {
                          const year = value.substring(0, 4);
                          const month = value.substring(4, 6);
                          const day = value.substring(6, 8);
                          return `${day}-${month}-${year}`;
                        }
                        if (tag === '00080030' && value) {
                          return formatTime(value);
                        }

                        return value ?? '';
                      } catch (error) {
                        return '';
                      }
                    };

                    return (< SendSeriesDetailCard
                      key={idx}
                      date={getValueSafely('00080020')}
                      time={getValueSafely('00080030')}
                      modality={getValueSafely('00080060')}
                      seriesNo={getValueSafely('00200011')}
                      images={getValueSafely('00201209')}
                      bodyPart={getValueSafely('00100040')}
                      seriesDisc={getValueSafely('0008103E')}
                      patPos={getValueSafely('0008103E')}
                      seriesInstanceUID={getValueSafely('0020000E')}
                      selectedItems={selectedItems}
                      setSelectedItems={setSelectedItems}
                      studyInstanceUID={getValueSafely('0020000D')}
                    />);
                  })
                }
              </div>
            </div>
        }
        <div className='py-2 flex space-x-4'>
          <button className='btn btn__white' name='Cancel' onClick={onClose}>Cancel</button>
          <Button className='bg-[#51A196] text-white font-medium px-4 py-1 rounded-md ml-3' name='Save' onClick={handleSendClick} >Send</Button>
        </div>
      </div>
    </div>
  );
};

export default SendFilesModal;
